import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { motion } from "framer-motion";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
// import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "core/Operations/toast";
import { Popconfirm } from "antd";
import {
  useGetProjectByIdQuery,
  useInsertProjectMutation,
  useUpdateProjectMutation,
} from "AppQuries/project/project";
import { projectCreationValidationSchema } from "core/Operations/ValidationSchema/projectValidationSchema";
import { ProjectInformationMapping } from "./Tab/ProjectInformationMapping";
import ProjectInformation from "./Tab/ProjectInformation";
import ClinetInformation from "./Tab/ClientInformation";
import ApprovalInfo from "./Tab/ApprovalInfo";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { BackIcon } from "Components/UI/Icon/Icons";

const steps = [
  { id: 0, name: "Information", component: ProjectInformation },
  { id: 1, name: "Client Details", component: ClinetInformation },
  { id: 2, name: "Approval Info", component: ApprovalInfo },
  // { id: 3, name: "Diesel", component: DieselUsage },
  // { id: 4, name: "Accident", component: VehicleAccident },
  // { id: 5, name: "Indemnity", component: VehicleIndemnity },
];

const EditProject = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const defaultClientDetails = {
    id: 0,
    companyCode: userData.companyCode,
    locationCode: userData.locationCode,
    projectCode: code,
    clientCompany: "",
    mainContact: "",
    contact2: "",
    remarks: "",
    clientProjectCode: 0,
    address: "",
    email: "",
    email2: "",
    clientProjectAbbr: "",
    isActive: true,
    createdBy: userData?.userName,
    createdDate: getCurrentFormattedDate(),
    modifiedBy: userData?.userName,
    modifiedDate: getCurrentFormattedDate(),
  };

  const defaultApprovalDetails = {
    id: 0,
    companyCode: userData.companyCode,
    locationCode: userData.locationCode,
    projectCode: code,
    modeOfApproval: "",
    clientWORefNo: "",
    clientContractNo: "",
    attachWO: "",
    workOrderMode: "",
    hardcopyReceived: true,
    remarks: "",
    technicalDetails: "",
    latitude: 0,
    longitude: 0,
    commercialDetails: "",
    quotationTemplate: "",
    quoteKey: "",
    minimumManday: 0,
    estimatedManHours: 0,
    estimatedManHourCost: 0,
    estimatedMaterialCost: 0,
    isActive: true,
    createdBy: userData?.userName,
    createdDate: getCurrentFormattedDate(),
    modifiedBy: userData?.userName,
    modifiedDate: getCurrentFormattedDate(),
  };

  const {
    data: projectData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetProjectByIdQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!userData?.companyCode,
    }
  );
  const [step, setStep] = useState(0);
  const {
    mutate: updateProject,
    isSubmitting,
    isError,
    error,
  } = useUpdateProjectMutation();

  const projectMethods = useForm({
    // defaultValues: {
    //   id: 0,
    //   companyCode: userData.companyCode,
    //   projectCode: "",
    //   projectName: "",
    //   projectStartDay: "",
    //   projectEndDay: "",
    //   projectStatus: "",
    //   approvedBy: "",
    //   groupCode: "",
    //   shiftCode: "",
    //   createUser: userData?.userName,
    //   createDate: getCurrentFormattedDate(),
    //   modifyUser: userData?.userName,
    //   modifyDate: getCurrentFormattedDate(),
    //   isActive: true,
    //   remarks: "",
    //   locationCode: userData.locationCode,
    //   type: 0,
    //   department: 0,
    //   clientProjectCode: 0,
    //   team: "",
    //   abbreviation: "",
    //   projectDescription: "",
    //   clientDetails: {
    //     id: 0,
    //     companyCode: userData.companyCode,
    //     locationCode: "",
    //     projectCode: "",
    //     clientCompany: "",
    //     mainContact: "",
    //     contact2: "",
    //     remarks: "",
    //     clientProjectCode: 0,
    //     address: "",
    //     email: "",
    //     email2: "",
    //     clientProjectAbbr: "",
    //     isActive: true,

    //     createdBy: userData?.userName,
    //     createdDate: getCurrentFormattedDate(),
    //     modifiedBy: userData?.userName,
    //     modifiedDate: getCurrentFormattedDate(),
    //   },
    //   approvalDetails: {
    //     id: 0,
    //     companyCode: userData.companyCode,
    //     locationCode: "",
    //     projectCode: "",
    //     modeOfApproval: "",
    //     clientWORefNo: "",
    //     clientContractNo: "",
    //     attachWO: "",
    //     workOrderMode: "",
    //     hardcopyReceived: true,
    //     remarks: "",
    //     technicalDetails: "",
    //     latitude: 0,
    //     longitude: 0,
    //     commercialDetails: "",
    //     quotationTemplate: "",
    //     quoteKey: "",
    //     minimumManday: 0,
    //     estimatedManHours: 0,
    //     estimatedManHourCost: 0,
    //     estimatedMaterialCost: 0,
    //     isActive: true,
    //     createdBy: userData?.userName,
    //     createdDate: getCurrentFormattedDate(),
    //     modifiedBy: userData?.userName,
    //     modifiedDate: getCurrentFormattedDate(),
    //   },
    //   projectsDetails: [
    //     {
    //       id: 0,
    //       companyCode: userData.companyCode,
    //       projectCode: "",
    //       employeeCode: 0,
    //       createdBy: userData?.userName,
    //       createdDate: getCurrentFormattedDate(),
    //       modifiedBy: userData?.userName,
    //       modifiedDate: getCurrentFormattedDate(),
    //       isActive: true,
    //     },
    //   ],
    // },
    resolver: yupResolver(projectCreationValidationSchema),
  });

  const navigate = useNavigate();

  const {
    setValue,
    handleSubmit,
    formState: { errors },
    watch,
  } = projectMethods;


  const StepComponent = steps[step].component;

  const moveTo = async (id) => {
    setStep(id);
  };

  const onSubmit = (payload) => {
    const existingEmployeeCodes = payload?.projectsDetails.map(
      (p) => p.employeeCode
    );
    const newEmployees = payload?.selectedEmployees
      .filter((emp) => !existingEmployeeCodes.includes(emp))
      .map((emp) => ({
        id: 0,
        companyCode: userData?.companyCode,
        projectCode: code,
        employeeCode: emp,
        createUser: userData?.userName,
        createDate: getCurrentFormattedDate(),
        modifyUser: userData?.userName,
        modifyDate: getCurrentFormattedDate(),
        isActive: true,
      }));

    const updatedList = payload?.projectsDetails
      .filter((p) => payload?.selectedEmployees.includes(p.employeeCode))
      .map((p) => ({
        ...p,
        modifyUser: userData?.userName,
        modifyDate: getCurrentFormattedDate(),
      }));

    payload.projectsDetails = [...updatedList, ...newEmployees];
    delete payload.selectedEmployees;

    updateProject(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success(data?.message || "Project Updated Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.project}${all_routes.project_list}`);
          }, 1000);
        } else {
          toast.warning(data?.message || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const onError = (errors) => {
    // Get the first field with error
    const firstErrorField = Object.keys(errors)[0];
    const tabIndex = ProjectInformationMapping[firstErrorField];

    if (tabIndex !== undefined) {
      setStep(tabIndex);
    }
  };

  const [loadingData, setLoadingData] = useState(true);
  useEffect(() => {
    if (Array.isArray(projectData) && projectData.length > 0) {
      Object.keys(projectData[0]).forEach((key) => {
        setValue(key, projectData[0][key]);
      });
      setValue(
        "selectedEmployees",
        projectData?.[0]?.projectsDetails?.map((d) => d.employeeCode)
      );

      if (projectData[0]?.clientDetails === null) {
        setValue("clientDetails", defaultClientDetails);
      }
      if (projectData[0]?.approvalDetails === null) {
        setValue("approvalDetails", defaultApprovalDetails);
      }
    }
    setLoadingData(false);
  }, [projectData]);

  if (isError) return <Error404 error={error} />;
  if (isLoading || isSubmitting || loadingData) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...projectMethods}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Project Details</h4>
                  </div>
                </div>
               
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save Project</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
                 <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Popconfirm
                      title="Are you sure to go back before saving?"
                      onConfirm={() =>
                        navigate(
                          `${all_routes.project}${all_routes.project_list}`
                        )
                      }
                    >
                      <button type="button" className="btn btn-secondary">
                        <BackIcon className="me-2" />
                        Back
                      </button>
                    </Popconfirm>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-solid nav-justified mb-3">
                        {steps?.map((item, index) => (
                          <li className="nav-item me-0" key={item.id}>
                            <Link
                              className={`nav-link step-${item.id} py-1 ${
                                index === step
                                  ? "active"
                                  : index < step
                                  ? "completed"
                                  : "in-completed"
                              }`}
                              id={item.id}
                              type="button"
                              // disabled
                              onClick={() => moveTo(item.id)}
                            >
                              {/* <motion.div
                                className={`w-10 h-10 mx-auto flex items-center justify-center font-bold rounded-full transition`}
                                initial={{ scale: 0.9 }}
                                animate={{ scale: index === step ? 1.1 : 1 }}
                                transition={{ duration: 0.9 }}
                              > */}
                              {item.name}
                              {/* </motion.div> */}
                            </Link>
                          </li>
                        ))}
                      </ul>
                      <div className="tab-content">
                        <motion.div
                          key={step}
                          initial={{ opacity: 0, x: 50 }}
                          animate={{ opacity: 1, x: 0 }}
                          exit={{ opacity: 0, x: -50 }}
                          transition={{ duration: 0.3 }}
                        >
                          <div className="tab-pane text-editor add-list">
                            <StepComponent userData={userData} />
                          </div>
                        </motion.div>
                        {/* <div className="tab-pane show active" id="tab1">
                          <Vehicle companyCode={userData?.companyCode} />
                        </div>
                        <div className="tab-pane" id="tab2">
                          <VehicleExpenses />
                        </div>
                        <div className="tab-pane" id="tab3">
                          <VehicleMaintenance />
                        </div>
                        <div className="tab-pane" id="tab4">
                          <DieselUsage />
                        </div>
                        <div className="tab-pane" id="tab5">
                          <VehicleAccident />
                        </div>
                        <div className="tab-pane" id="tab6">
                          <VehicleIndemnity />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditProject;
